module.exports = __webpack_public_path__ + "img/Intersection 3@2x.16af8944.png";